export const EN_US: Record<string, string> = {
  选择分析信息: 'Select Analysis Information',
  切换指标: 'Switch indicator',
  确定: 'Ok',
  取消: 'Cancel',
  重置: 'Reset',
  请输入关键字搜索: 'Please enter a keyword search',
  搜索: 'Search',
  恢复: 'Recover',
  '已选 {} 项': 'selected {} item',
  所选项: 'selected items',
  选择下钻维度: 'Select drill down dimension',
  恢复默认: 'Restore default',
  搜索字段: 'Search field',

  // switcher
  行列切换: 'Switch Dimensions',
  行头: 'Rows',
  列头: 'Cols',
  值: 'Values',
  展开子项: 'Expand Children',

  // sort
  首字母: 'Alphabetical order',
  手动排序: 'Custom order',
  其他字段: 'Other field',
  高级排序: 'Advanced order',
  设置顺序: 'SetManual',
  可选字段: 'Fields',
  '按以下规则进行排序（优先级由低到高）':
    'Order according to the following rules (from low to high priority)',
  按: 'By',
  说明: 'Description: ',

  // export
  复制原始数据: 'Copy raw data',
  复制格式化数据: 'Copy formatted data',
  下载原始数据: 'Download raw data',
  下载格式化数据: 'Download formatted data',
  操作成功: 'Operation successful',
  操作失败: 'Operation failed',

  // strategy
  时间: 'Date',
  指标: 'Measure',
  目标值: 'Target Value',
};
